import { render, staticRenderFns } from "./OfficeList.vue?vue&type=template&id=b362b2c4&"
import script from "./OfficeList.vue?vue&type=script&lang=ts&"
export * from "./OfficeList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports